module.exports = __webpack_public_path__ + "img/x3.54e25f11.jpg";